import { get } from "utils/lodash";
import { gql, DocumentNode } from "@apollo/client";
import { IDefinition } from "types/utils/graphql";
// import renderPropsComposer from "../renderPropsComposer";
const getQuery = (selections: string, defs: object, type: string) => {
  const SHAPE_QUERY = get(defs, `GQL_SHAPE_QUERY.${type}`) || "";
  const findSelection = selections || get(defs, "baseSelection") || "";
  try {
    const shapeQuerySelection = SHAPE_QUERY.replace(
      /{{ selections }}/g,
      findSelection.trim()
    );
    return shapeQuerySelection;
  } catch (error: any) {
    console.error("Builder getQuery\n", { message: error?.message ?? "" });
  }
};

const builder = {
  createDefinition: (definition: IDefinition) => {
    return {
      paramSelection: `
        limit
        page
        offset
        totalDocs
        totalPages
      `,

      ...definition,
    };
  },

  getBaseQuery: (
    selections: string,
    defs: IDefinition | object
  ): DocumentNode | null => {
    const baseQuery = get(defs, "baseQuery") || "";
    const baseSelection = getQuery(selections, defs, "BASE");
    if (!baseQuery || !baseSelection) {
      console.warn(`getBaseQuery ${baseQuery}: check definition`);
      return null;
    }
    const query = `
    query ${baseQuery} ($id: String!) {
            ${baseQuery}(id: $id) {
                ${baseSelection}
                ${selections}
            }
        }
    `;
    // console.log(`query ${baseQuery}\n`, `@query builder`, query);
    return gql`
      ${query}
    `;
  },
  getFindQuery: (
    selections: string,
    defs: IDefinition | object
  ): DocumentNode | null => {
    const findQuery = get(defs, "GQL_ACTIONS.FIND") || "";
    // Ưu tiên sử dụng selections nếu được cung cấp
    // Nếu không có selections, sử dụng GQL_SELECTIONS.FIND từ định nghĩa
    // Nếu cả hai đều không có, sử dụng baseSelection từ định nghĩa
    // Cuối cùng, nếu không có gì được cung cấp, sử dụng chuỗi rỗng
    const findSelection = getQuery(selections, defs, "FIND");
    const paramSelection = get(defs, "paramSelection") || "";
    const name = get(defs, "nameInput") || get(defs, "name") || "";

    if (!findQuery || !findSelection || !name) {
      console.warn("@findQuery", findQuery);
      console.warn("@findSelection", findSelection);
      console.warn("@name", name);
      console.warn(`getFindQuery of ${name}: check definition of ${name}`);
      return null;
    }
    const query = `
        query ${findQuery}($limit: Int, $page: Int, $sort: String, $where: ${name}_where) {
            ${findQuery}(limit: $limit, page: $page, sort: $sort, where: $where) {
                ${findSelection}
                ${paramSelection}
            }
        }
    `;

    console.log(`MODEL ${name}\n`, `[find] @query builder`, query);
    return gql`
      ${query}
    `;
  },
  getCreateQuery: (
    selections: string,
    defs: IDefinition | object
  ): DocumentNode | null => {
    const createQuery = get(defs, "GQL_ACTIONS.CREATE") || "";
    const createSelection =
      getQuery(selections, defs, "CREATE") ||
      getQuery(selections, defs, "BASE");
    const name = get(defs, "nameInput") || get(defs, "name") || "";

    if (!createQuery || !createSelection || !name) {
      console.warn(`getCreateQuery of ${name}: check definition of ${name}`);
      return null;
    }

    const query = `
            mutation ${createQuery}($data: mutation${name}Input!) {
                ${createQuery}(data: $data) {
                    ${createSelection}
                }
            }
        `;
    // console.log(`MODEL ${name}\n`, `[create] @query builder`, query);
    return gql`
      ${query}
    `;
  },
  getDeleteQuery: (
    selections: string,
    defs: IDefinition | object
  ): DocumentNode | null => {
    const deleteQuery = get(defs, "GQL_ACTIONS.DELETE") || "";
    const deleteSelection =
      getQuery(selections, defs, "DELETE") ||
      getQuery(selections, defs, "BASE");
    const name = get(defs, "nameInput") || get(defs, "name") || "";

    if (!deleteQuery || !deleteSelection || !name) {
      console.warn(`getDeleteQuery of ${name}: check definition of ${name}`);
      return null;
    }
    const query = `
              mutation ${deleteQuery}($id: String!) {
                  ${deleteQuery}(id: $id) {
                      ${deleteSelection}
                  }
              }
          `;
    // console.log(`MODEL ${name}\n`, `[delete]@query builder`, query);
    return gql`
      ${query}
    `;
  },

  getDeactivateQuery: () => {},
  getUpdateQuery: (
    selections: string,
    defs: IDefinition | object
  ): DocumentNode | null => {
    const updateQuery = get(defs, "GQL_ACTIONS.UPDATE") || "";
    const updateSelection = getQuery(selections, defs, "UPDATE");
    const name = get(defs, "nameInput") || get(defs, "name") || "";
    console.log("updateQuery", updateQuery);
    console.log("updateSelection", updateSelection);
    console.log("name", name);
    if (!updateQuery || !updateSelection || !name) {
      console.warn(`getUpdateQuery of ${name}: check definition of ${name}`);
      return null;
    }
    const query = `
            mutation ${updateQuery}($id: String!, $data: mutation${name}UpdateInput!) {
                ${updateQuery}(id: $id, data: $data) {
                    ${updateSelection}
                }
            }
        `;
    // console.log(`MODEL ${name}\n`, `[update]@query builder`, query);
    return gql`
      ${query}
    `;
  },

  // BUILD CUSTOM QUERIES
  getUpdateUserProfileQuery: (
    selections: string,
    defs: IDefinition | object
  ) => {
    const updateQuery = get(defs, "GQL_ACTIONS.UPDATE") || "";
    const updateSelection = getQuery(selections, defs, "UPDATE");
    if (!updateQuery || !updateSelection) {
      console.warn(
        `getUpdateUserProfileQuery: check definition of updateQuery and baseSelection`
      );
      return null;
    }
    return gql`
            mutation ${updateQuery}($input: UpdateUserProfileInput!) {
                ${updateQuery}(input: $input) {
                    ${updateSelection}
                    ${selections}
                }
            }
        `;
  },
  getCustomGQL: (shapeQuery: string) => {
    // console.log({ shapeQuery });
    return gql`
      ${shapeQuery}
    `;
  },
};

export default builder;
